var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("q-form", { ref: "editForm" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "페기물 처리결과" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _vm.editable
                            ? _c("c-btn", {
                                attrs: { label: "저장", icon: "save" },
                              })
                            : _vm._e(),
                          _vm.editable
                            ? _c("c-btn", {
                                attrs: { label: "삭제", icon: "remove" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-plant", {
                          attrs: {
                            required: "true",
                            type: "edit",
                            name: "col0",
                          },
                          model: {
                            value: _vm.data.col0,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "col0", $$v)
                            },
                            expression: "data.col0",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-field", {
                          attrs: {
                            editable: _vm.editable,
                            data: _vm.data,
                            deptValue: "col2",
                            type: "dept_user",
                            label: "작성부서 & 작성자",
                            name: "col3",
                          },
                          model: {
                            value: _vm.data.col3,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "col3", $$v)
                            },
                            expression: "data.col3",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "인계번호",
                            name: "col5",
                          },
                          model: {
                            value: _vm.data.col5,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "col5", $$v)
                            },
                            expression: "data.col5",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-datepicker", {
                          attrs: { label: "인계일자", name: "col1" },
                          model: {
                            value: _vm.data.col1,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "col1", $$v)
                            },
                            expression: "data.col1",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("c-select", {
                          attrs: {
                            comboItems: _vm.wasteItems,
                            type: "edit",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "col5",
                            label: "폐기물 종류",
                          },
                          model: {
                            value: _vm.data.col5,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "col5", $$v)
                            },
                            expression: "data.col5",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "위탁량",
                            name: "col22",
                          },
                          model: {
                            value: _vm.data.col22,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "col22", $$v)
                            },
                            expression: "data.col22",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("c-select", {
                          attrs: {
                            codeGroupCd: "WEIGHT_UNIT",
                            type: "edit",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "col14",
                            label: "단위",
                          },
                          model: {
                            value: _vm.data.col14,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "col14", $$v)
                            },
                            expression: "data.col14",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "운반자명",
                            name: "col5",
                          },
                          model: {
                            value: _vm.data.col5,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "col5", $$v)
                            },
                            expression: "data.col5",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "차량번호",
                            name: "col22",
                          },
                          model: {
                            value: _vm.data.col22,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "col22", $$v)
                            },
                            expression: "data.col22",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "처리자명",
                            name: "col14",
                          },
                          model: {
                            value: _vm.data.col14,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "col14", $$v)
                            },
                            expression: "data.col14",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "처리방법",
                            name: "col14",
                          },
                          model: {
                            value: _vm.data.col14,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "col14", $$v)
                            },
                            expression: "data.col14",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "처리장소",
                            name: "col14",
                          },
                          model: {
                            value: _vm.data.col14,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "col14", $$v)
                            },
                            expression: "data.col14",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "인계자명",
                            name: "col14",
                          },
                          model: {
                            value: _vm.data.col14,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "col14", $$v)
                            },
                            expression: "data.col14",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }